import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { LuFileQuestion } from "react-icons/lu";

import AssetMedia from "@/components/AssetMedia";

/**
 * The media area and the two chevrons that walk the list. Everything about
 * playback and trimming belongs to AssetMedia/VideoPlayer — this only places
 * them and forwards the trim props it was handed.
 *
 * `mediaKey` remounts the player when the entry changes: a video element that
 * merely swaps `src` keeps the previous clip's trim handles and playhead.
 *
 * @input {asset: {_id: 'a1', mediaType: 'video'}, mediaKey: 'e1', initialTrimInTime: 2}
 */
export default function AssetsListAssetPreviewStage({
  asset,
  mediaKey,
  initialTrimInTime,
  initialTrimOutTime,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onTrimChange,
  onMediaInfoChange,
}) {
  return (
    <div className="AssetsListAssetPreview__stage relative flex-1 min-h-0 min-w-0 bg-black flex items-center justify-center">
      {asset ? (
        <AssetMedia
          key={mediaKey}
          asset={asset}
          autoPlay
          allowTrim
          constrainPlaybackToTrim
          initialTrimInTime={initialTrimInTime}
          initialTrimOutTime={initialTrimOutTime}
          onTrimChange={onTrimChange}
          onMediaInfoChange={onMediaInfoChange}
        />
      ) : (
        <div className="AssetsListAssetPreview__unavailable flex flex-col items-center gap-3 text-secondary-foreground/50">
          <LuFileQuestion className="w-16 h-16" />
          <span className="text-sm">This asset is no longer available</span>
        </div>
      )}

      {hasPrevious && (
        <button
          id="AssetsListAssetPreview__previous"
          type="button"
          title="Previous"
          onClick={onPrevious}
          className="AssetsListAssetPreview__previous absolute left-3 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 cursor-pointer">
          <FiChevronLeft className="w-5 h-5" />
        </button>
      )}

      {hasNext && (
        <button
          id="AssetsListAssetPreview__next"
          type="button"
          title="Next"
          onClick={onNext}
          className="AssetsListAssetPreview__next absolute right-3 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 cursor-pointer">
          <FiChevronRight className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
